






























import { computed, defineComponent } from '@vue/composition-api';
import { ActionSheet } from '@upc/vant';
import { getLocationId } from '@/utils/tools';
import urlExt from '@/kits/url';

export default defineComponent({
  name: 'DrainageSheet',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: { ActionSheet },
  setup(props, { emit, root }) {
    const visible = computed(() => {
      return props.value;
    });
    const from = urlExt.getQuery('from');
    const locationName = urlExt.getQuery('location');

    const onClose = (type: number = 1) => {
      emit('input', false);
      root.zstrack({
        name: 'JF1_005',
        dl_from: from,
        dl_location: getLocationId(locationName || 'paisou'),
        type
      });
    };
    const onConfirm = () => {
      root.zstrack({
        name: 'JF1_004',
        dl_from: from,
        dl_location: getLocationId(locationName || 'paisou')
      });
      emit('onConfirm');
    };
    return { visible, onClose, onConfirm };
  }
});
